<script>
import Order from '../../models/Order'
import OrderDetailTable from './OrderDetailTable'
import { action } from '../../store/types'
import { mapActions } from 'vuex'
import OverlayLoading from '../Admin/OverlayLoading'
import CONST from '../../const/OrderConstant'
import UserOrderStatus from './UserOrderStatus'
import ConfirmModal from '../ConfirmModal'
import PriceBox from '../PriceBox'
import OrderConstant from '../../const/OrderConstant'
import OrderHistory from '../../models/OrderHistory'
import OrderProductItem from './OrderProductItem.vue'
import OrderProductNotListItem from './OrderProductNotListItem.vue'

export default {
    name: 'order-detail',

    data() {
        return {
            order: new Order(),
            orderHistory: new OrderHistory(),
            busy: false,
            OrderConstant,
        }
    },

    props: {
        data: {},
    },

    computed: {
        // キャンセルボタン
        showCancelBtn() {
            return this.order.latestOrderHistory.status === CONST.ORDER_STATUS_WSG_APPROVAL
        },
        // 確定ボタン
        showConfirmBtn() {
            return this.order.latestOrderHistory.status === CONST.ORDER_STATUS_WSG_APPROVAL
        },
    },

    created() {
        this.order = new Order({ ...eval(this.data).order })
        this.orderHistory = this.order.latestOrderHistory
    },

    methods: {
        ...mapActions([action.LOADING_UPDATE]),
        async reOrder() {
            try {
                this.busy = true
                await axios.post(
                    '/api/cart/add',
                    eval(this.data).order.latest_order_history.order_items
                )
                window.location.href = '/cart'
            } catch (e) {
                console.error(e)
            } finally {
                this.busy = false
            }
        },

        goEditPage() {
            window.location.href = `/mypage/order/detail-edit/${this.order.encryptCode}`
        },

        showPdf(key) {
            window.open(
                `/pdf/${key}/${this.order.encryptCode}`,
                null,
                'top=0, left=0, width=800, height=800'
            )
        },

        onOrderCancel() {
            this.toSubmit('cancel')
        },

        onOrderFixed() {
            this.toSubmit('fixed')
        },

        toSubmit(actionName) {
            this.$refs.orderDetailForm.action = `/order/${actionName}/${this.order.encryptCode}`
            this.$nextTick(() => this.$refs.orderDetailForm.submit())
        },
    },

    components: {
        OrderDetailTable,
        OverlayLoading,
        UserOrderStatus,
        ConfirmModal,
        PriceBox,
        OrderProductItem,
        OrderProductNotListItem,
    },
}
</script>

<style lang="scss" scoped>
.status-alert {
    font-weight: bold;
    padding: 0 15px;
    border-radius: 5px;
    font-size: 21px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/order/OrderDetail.vue